<div class="container justify-content-center my-5">
  <div class="mainWrap">
    <img src="assets/images/home/ifpmain.jpg" class="img-fluid shadow-sm" alt="Virsa smart classroom interactive flat panel" />
  </div>
  <div class="row justify-content-center text-center">
    <div class="col-md-8 mb-4">
      <h2 class="mb-3 headingBL">
        Engage Your Students, Elevate Your Teaching Through
        <span>VIRSA Interactive Flat Panel</span>
      </h2>
      <p class="vtext">
        Transform any classroom into a vibrant learning hub with VIRSA’s
        cutting-edge interactive flat panels. Foster collaboration, boost
        engagement, and ignite creativity in every lesson.
      </p>
      <div class="d-flex justify-content-center align-items-center mt-4">
        <a class="btnGlobal--primary me-4" href="/assets/pdf/Virsa-Panel-Brochure.pdf" target="_blank">Download
          Brochure</a>
        <div class="btnGlobal--primary" routerLink="/interactive-flat-panel-smart-classroom">
          View More..
        </div>
      </div>
    </div>
  </div>

  <div class="my-5">
    <h3 class="mb-4 text-center headingBL">
      Explore the <span>Dynamic Capabilities</span> of VIRSA Interactive Panels
    </h3>
    <div class="row g-4">
      <div class="col-md-4" *ngFor="let feature of featureData">
        <app-feature-card [title]="feature.title" [iconSrc]="feature.iconSrc" [description]="feature.description">
        </app-feature-card>
      </div>
    </div>
  </div>

  <!-- Shutter Accessory Section -->
  <div class="container my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <img src="assets/images/home/sliding-Board.png" alt="Virsa interactive flat panel shutter accessory" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 class="fw-bold mb-3 headingBL">
          Dual-Purpose Shutter: <span>Protection & Collaboration</span>
        </h3>
        <p class="mb-3">
          The VIRSA IFP shutter serves as both a protective cover and a writable
          whiteboard surface. When not in use, it shields the screen from
          damage. When teaching offline, it transforms into a traditional
          whiteboard – ideal for quick notes, illustrations, or spontaneous
          lessons.
        </p>
        <ul class="list-unstyled">
          <li class="mb-2">
            ✅ Protects the IFP screen from dust and physical impact
          </li>
          <li class="mb-2">✅ Converts into a usable dry-erase whiteboard</li>
          <li class="mb-2">
            ✅ Ideal for hybrid or offline teaching scenarios
          </li>
          <li class="mb-2">✅ Easy to clean and maintain</li>
        </ul>
        <div class="d-flex justify-content-left align-items-center mt-4">
          <a class="btnGlobal--primary me-4" href="/assets/pdf/Shutter-Brochure.pdf" target="_blank">Download
            Brochure</a>
        </div>
      </div>
    </div>
  </div>
</div>